import { axiosGet, axiosPost, axiosPostWithFile } from "./apiClient";

const BASE_URL = process.env.REACT_APP_BASE_URL + "/category";

const getAllCategories = async ({
    limit = 15,
    page = 0,
    status = null,
    search = null,
    excludeID = null,
    sortModel = [],
    filterModel = {},
}) => {
    try {
        let finalSearch = search;

        if (!finalSearch && filterModel?.quickFilterValues?.length) {
            finalSearch = filterModel.quickFilterValues.join(" ").trim() || null;
        }

        return await axiosGet(`${BASE_URL}/getall`, {
            limit,
            page,
            status,
            search: finalSearch,
            excludeID,
            sort: sortModel,
        });
    } catch (error) {
        console.error("Error fetching categories:", error);
        throw error;
    }
};

const categoryAPI = {
    getAllCategories,
    getCategoryById: (id) => axiosGet(`${BASE_URL}/view/${id}`),
    createCategory: (formData) => axiosPostWithFile(`${BASE_URL}/add`, formData),
    updateCategory: (id, formData) => axiosPostWithFile(`${BASE_URL}/add/${id}`, formData),
    updateCategoryStatus: (data) => axiosPost(`${BASE_URL}/status`, data),
    getCategoryStatusLogs: (params) => axiosGet(`${BASE_URL}/status/log`, params),
};

export default categoryAPI;
